import type { UnlockedAchievement } from '@/lib/achievements/process';

interface Props {
  achievement: UnlockedAchievement;
  onDismiss: () => void;
}

export function AchievementCelebrationToast({ achievement, onDismiss }: Props) {
  return (
    <div className="toast-slide-up fixed inset-x-4 bottom-24 z-50 mx-auto max-w-phone">
      <div className="flex items-center gap-3 rounded-2xl border-2 border-gold bg-navy p-4 text-cream shadow-xl">
        <span className="text-3xl">{achievement.icon}</span>
        <div className="min-w-0 flex-1">
          <div className="text-[10px] font-bold tracking-widest text-gold">ACHIEVEMENT UNLOCKED</div>
          <div className="font-serif text-lg font-bold">{achievement.name}</div>
          <div className="text-xs text-white/60">{achievement.desc}</div>
        </div>
        <button type="button" onClick={onDismiss} className="shrink-0 rounded-full bg-white/10 px-3 py-1 text-xs font-bold">OK</button>
      </div>
    </div>
  );
}
